import { Check, X } from "lucide-react";

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";

import { useOpenUrl } from "../../hooks/useOpenUrl";
import { useCallContext } from "./CallContext";

export const CallDoneDialog = () => {
  const { leaveCall, roomId } = useCallContext();

  return <CallDoneDialogUI leaveCall={leaveCall} roomId={roomId} />;
};
export interface CallDoneDialogUIProps {
  roomId: string;
  leaveCall: () => void;
}

export const CallDoneDialogUI = ({
  roomId,
  leaveCall,
}: Readonly<CallDoneDialogUIProps>) => {
  const openUrl = useOpenUrl();

  const handleViewAnalysis = () => {
    const dashboardUrl = import.meta.env.VITE_DASH_URL;
    if (dashboardUrl) {
      // Navigate to the specific call analysis page
      const callAnalysisUrl = `${dashboardUrl}/calls/${roomId}`;
      openUrl(callAnalysisUrl);
    } else {
      console.error("Dashboard URL not configured");
    }
    // Also leave the call after opening the dashboard
    leaveCall();
  };

  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <Button size="sm" variant="default">
          <Check size={16} className="mr-2" /> Done
        </Button>
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <div className="flex flex-row items-center justify-between">
            <div className="flex-grow">
              <AlertDialogTitle>Leave call </AlertDialogTitle>
            </div>
            <div>
              <AlertDialogCancel>
                <X size={16} />
              </AlertDialogCancel>
            </div>
          </div>
          <AlertDialogDescription>
            Would you like to view your report for this call?
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={() => leaveCall()}>
            Leave call
          </AlertDialogCancel>
          <AlertDialogAction onClick={handleViewAnalysis}>
            View analysis
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
